module.exports = __webpack_public_path__ + "img/fail_blue.c06917c9.png";